import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class FacetToggle extends React.Component {
  constructor(props) {
    super(props);
    this.totalLinks = typeof props.facetLinks !== "undefined" ? props.facetLinks.length : 0;
  }

  handleClick(value) {
    const { handleUpdate, selectedFacets, facetLinks } = this.props;
    const facetIDs = (typeof facetLinks !== "undefined") ? facetLinks.map((link) => link.id) : [];

    // Keep the facets not included in the list.temp
    const filteredFacets = selectedFacets.filter((item) => (facetIDs.indexOf(item) === -1)).concat(value);

    handleUpdate({ page: 1, facet: filteredFacets });
  }

  renderFacetLinks = (facetLink, key) => {
    const { selectedFacets } = this.props;
    const isSelected = (selectedFacets.indexOf(facetLink.id) !== -1);

    const buttonClass = classNames("btn btn--link", {
      "is-active": isSelected,
      "is-first": key === 0,
      "is-last": key + 1 >= this.totalLinks,
    });

    return (
      <span key={key}>
        <button
          onClick={() => this.handleClick(facetLink.id)}
          className={buttonClass}
        >
          {facetLink.label}
        </button>
      </span>
    );
  };

  render() {
    const { facetLinks } = this.props;

    return (
      <div className="search__info-sort">
        {facetLinks.length > 0 &&
          facetLinks.map((facetLink, i) => {
            return this.renderFacetLinks(facetLink, i);
          })}
      </div>
    );
  }
}

const { func, array } = PropTypes;

FacetToggle.propTypes = {
  handleUpdate: func,
  selectedFacets: array,
  facetLinks: array.isRequired,
};
